import map from 'lodash/map';

import canClockMassShiftEntries from '@/mixins/clocking/mass/canClockMassShiftEntries';

import constants from '@/constants';

export default {
  mixins: [canClockMassShiftEntries],

  methods: {
    createMassShiftClockIn(
      shiftClockInParameters,
      successCallback,
      lastly,
    ) {
      const timeEntries = map(
        shiftClockInParameters,
        (config) => {
          let timeEntryRequest = null;
          this.getBaseTimeEntryRequest(
            constants.EntryType.CLOCK_IN,
            config.timeZoneOffset,
            false,
            null,
            config.timeType ? config.timeType.id : null,
            (baseTimeEntryRequest) => {
              timeEntryRequest = baseTimeEntryRequest;
              timeEntryRequest.employeeAssignmentId = config.employeeAssignmentId;
              timeEntryRequest.timePairCustomFieldValues = config.timePairCustomFieldValues;
            },
          );
          return timeEntryRequest;
        },
      );

      this.createShiftTimeEntries(timeEntries, successCallback, lastly);
    },
  },
};
